import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';

import { section, title } from './Section.less';

const Section = ({ children, date }) => (
  <Grid fluid className={section}>
    <Row>
      <Col xs={12}>
        <h6 className={title} children={date} />
      </Col>
    </Row>
    {children}
  </Grid>
);

Section.propTypes = {
  date: PropTypes.string,
  children: PropTypes.node,
};

export default Section;
